<template>
    <div
        v-tooltip="{ popperClass: 'VTooltip--dark', content: 'Data was imported. No document available.' }"
        class="inline-flex text-eidSecureBlue-50 items-center gap-2 text-xs"
        data-test-id="DocumentDataOnlyBadge"
    >
        <EidIcon
            :icon-src="tableIcon"
            alt="Data Only"
        />
        <span>Data Only</span>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { faTable } from '@fortawesome/pro-regular-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    export default defineComponent({
        name: 'DocumentDataOnlyBadge',
        components: { EidIcon },
        data() {
            return {
                tableIcon: faTable,
            };
        },
    });
</script>
